import React from 'react';
import clsx from 'clsx';
import { Collapse } from 'react-collapse';
import { Typography, getTypographyDefaultColor } from '@ag1/ui';
import IconPlusToMinus from 'shared/ui/Icon/24/IconPlusToMinus/IconPlusToMinus';
import CustomPortableText from 'shared/studio/PortableText/PortableText';
import { BenefitsList as BenefitsListProps } from 'types/studio/studio';
import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import { AccordionItemProps } from './AccordionItem.types';
import styles from './AccordionItem.module.scss';

export const AccordionItem = ({
  iheadline,
  portableText,
  isOpen,
  onToggle,
  theme
}: Pick<BenefitsListProps['accordionItems'][number], 'iheadline' | 'portableText'> &
  Pick<BenefitsListProps, 'theme'> &
  AccordionItemProps) => (
  <div
    className={clsx(styles.question, isOpen && styles.active, getThemeCSSClass(theme))}
    data-testid="item">
    <div
      className={styles.headline}
      role="button"
      data-testid="title"
      onClick={onToggle}
      data-gtm-skip-global
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          onToggle();
        }
      }}>
      <Typography
        className={styles.headlineText}
        variant="subtitle"
        size="2"
        component="h4"
        weight="700"
        color={getTypographyDefaultColor(theme)}
        noPadding>
        {iheadline}
      </Typography>
      <IconPlusToMinus className={clsx(styles.icon, getThemeCSSClass(theme))} />
    </div>
    <Collapse isOpened={isOpen}>
      <Typography
        variant="body"
        size="1"
        component="div"
        noPadding
        className={styles.text}
        color={getTypographyDefaultColor(theme)}>
        <CustomPortableText value={portableText} />
      </Typography>
    </Collapse>
  </div>
);
